let apiBase = {
  queryList:'/api/batchIdentifyExpire/queryPage',
  createTask:'/api/batchIdentifyExpire/addTask',
  queryDetail:'/api/batchIdentifyExpire/queryApkPage',
  exportApk:'/api/batchIdentifyExpire/exportApk',
}
let ImportTaskServerObject = null
class ImportTaskServer{
  constructor(){}

  // 查询导入任务列表
  queryList(data={}){
    return $http({
      url: apiBase.queryList,
      method: 'post',
      data: data,
    })
  }
  // 创建导入任务（上传Excel，form-data）
  createTask(data={}){
    return $http({
      url: apiBase.createTask,
      method: 'post',
      data: data,
    })
  }
  // 查询导入任务数据集状态
  queryDetail(data={}){
    return $http({
      url: apiBase.queryDetail,
      method: 'post',
      data: data,
    })
  }
  // 导出导入任务数据集（form-data）
  exportApk(data={}){
    return $http({
      url: apiBase.exportApk,
      method: 'post',
      data: data,
    })
  }
}
function singleImportTaskServer(){
  if(ImportTaskServerObject === null){
    ImportTaskServerObject = new ImportTaskServer()
  }
  return ImportTaskServerObject
}
export default singleImportTaskServer()
